var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('agile-table',{attrs:{"data-type":'projectsInvoice',"table-meta":_vm.tableMeta,"data":_vm.projects,"filter-meta":_vm.filterMeta,"column-meta":_vm.columnMeta,"show-context-menu":true},on:{"fieldAction":_vm.fieldAction,"tableAction":_vm.tableAction,"rowAction":_vm.rowAction}}),_vm._v(" "),_c('slideout-panel')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-740a3e34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Admin/Invoices/InvoicesPage.vue
// module id = null
// module chunks = 